<template>
  <div class="geolocation">
    <v-dialog :value="show" max-width="380" persistent>
      <v-card min-height="400">
        <v-card-text>
          <v-layout
            column
            align-center
            justify-center
            style="min-height: 400px"
          >
            <div
              v-if="error"
              class="d-flex flex-column align-center justify-space-between"
            >
              <div>
                <v-icon color="red accent-1" size="100"
                  >mdi-map-marker-off</v-icon
                >
              </div>
              <div
                class="heading red--text text--accent-1 pb-4 pt-6 text-center"
              >
                {{ error }}
              </div>
              <div class="mt-4">
                <v-btn
                  text
                  x-small
                  color="grey darken-1"
                  @click="$emit('change', !show)"
                >
                  {{ $t("fechar") }}
                </v-btn>
              </div>
            </div>
            <div
              v-else-if="!successLinkToGoogleMaps"
              class="d-flex flex-column align-center"
            >
              <div>
                <v-progress-circular
                  indeterminate
                  width="1"
                  size="200"
                  color="blue"
                >
                  <v-icon color="orange lighten-1" size="100"
                    >mdi-map-marker</v-icon
                  >
                </v-progress-circular>
              </div>
              <div class="heading grey--text pb-4 pt-6">
                {{ $t("aguarde_obtendo_localizacao") }}
              </div>
              <div class="mt-4">
                <v-btn
                  text
                  x-small
                  color="grey darken-1"
                  @click="$emit('change', !show)"
                >
                  {{ $t("cancelar") }}
                </v-btn>
              </div>
            </div>
            <div
              v-else-if="successLinkToGoogleMaps"
              class="d-flex flex-column align-center"
            >
              <div>
                <v-icon color="green lighten-1" size="100"
                  >mdi-map-marker-check</v-icon
                >
              </div>
              <div class="heading grey--text pb-4 pt-6">
                {{ $t("localizacao_encontrada") }}
              </div>
              <div class="heading grey--text pb-4 pt-6">
                <v-btn
                  color="light-blue"
                  dark
                  link
                  :href="successLinkToGoogleMaps"
                  target="_blank"
                  @click="goToGoogleMaps"
                >
                  {{ $t("ver_google_maps") }}
                  <v-icon class="ml-2" small dark>mdi-open-in-new</v-icon>
                </v-btn>
              </div>
              <div class="mt-4">
                <v-btn
                  text
                  x-small
                  color="grey darken-1"
                  @click="$emit('change', !show)"
                >
                  {{ $t("fechar") }}
                </v-btn>
              </div>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["show"],
  model: {
    prop: "show",
    event: "change",
  },
  data: () => ({
    error: "",
    successLinkToGoogleMaps: "",
  }),
  watch: {
    show(nextValue) {
      if (nextValue) {
        this.getLocation();
      }
    },
  },
  methods: {
    goToGoogleMaps() {
      this.$emit("change", !this.show);
      this.successLinkToGoogleMaps = "";
    },
    getLocation() {
      this.successLinkToGoogleMaps = "";

      if (window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(
          showPosition,
          showError
        );
      } else {
        this.error = this.$t("geolocalizacao_nao_suportada");
      }

      const self = this;

      function showPosition(position) {
        const lat = position.coords.latitude;
        const lon = position.coords.longitude;

        const time = setTimeout(() => {
          self.successLinkToGoogleMaps = `http://maps.google.com/maps?&z=15&mrt=yp&t=k&q=${lat}+${lon}`;
          clearTimeout(time);
        }, 2000);
      }

      function showError(error) {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            self.error = self.$t("voce_deve_ativar_permissao_geolocalizador");
            break;
          case error.POSITION_UNAVAILABLE:
            self.error = self.$t("localizacao_indisponivel");
            break;
          case error.TIMEOUT:
            self.error = self.$t("tempo_busca_expirou");
            break;
          case error.UNKNOWN_ERROR:
            self.error = self.$t("ops_erro_desconhecido");
            break;
        }
      }
    },
  },
};
</script>

<style scoped></style>
